import React, { PureComponent } from 'react';
import { appConfig } from 'configurations';
import { externalScriptHelper } from 'helpers';

export class FortAwesomeLoader extends PureComponent {
    containerRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
        this.loadFortAwesomeKit();
    }

    render(): JSX.Element {
        return (
            <div className='fort-awesome-loader' ref={this.containerRef}>
            </div>
        );
    }

    loadFortAwesomeKit() {
        const scriptNode = document.createElement('script');
        scriptNode.src = appConfig.fortAwesomeKitUrl;
        scriptNode.type = 'text/javascript';
        scriptNode.async = true;
        scriptNode.onload = () => this.loadFortAwesomeStyles();

        this.containerRef.current!.appendChild(scriptNode);
    }

    loadFortAwesomeStyles() {
        const fortAwesomeConfig = externalScriptHelper.getExternalScript<any>('FortAwesomeConfig');
        const stylesUrl = `https://${fortAwesomeConfig.useUrl}/woff2.css`;

        const cssNode = document.createElement('link');
        cssNode.href = stylesUrl;
        cssNode.type = 'text/css';
        cssNode.rel = 'stylesheet';
        cssNode.media = 'all';

        this.containerRef.current!.appendChild(cssNode);
    }
}